import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { useFindIngestionSettings } from "~/gen/api"
import { IngestionClientSettings } from "~/pages/Admin/IngestionSettings/IngestionClientSettings"

export function IngestionClientSettingsLayout() {
  const findIngestionSettings = useFindIngestionSettings()

  return (
    <DataFetchWrapper query={findIngestionSettings}>
      {({ data }) => <IngestionClientSettings data={data.data} />}
    </DataFetchWrapper>
  )
}
